<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 80px"
>
  <mat-tab-group
    mat-align-tabs="center"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  >
    <mat-tab label="Manage users">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            [formGroup]="formularioUsuarios"
          >
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Type of Account</mat-label>
              <mat-select
                disableRipple
                formControlName="permiso"
                (selectionChange)="OnChangePerfil($event.value)"
                
              >
                <mat-option value="0">ADMIN</mat-option>
                <mat-option value="2">CUSTOMER</mat-option>
                <mat-option value="1">WAREHOUSE</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <mat-label>Select Customer</mat-label>
              <mat-select formControlName="customer">
                <mat-option
                  *ngFor="let item of PlaceOrderCustomer"
                  [value]="item.key"
                  >{{ item.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Active ?</mat-label>
              <mat-select disableRipple formControlName="activo">
                <mat-option value="1">Yes</mat-option>
                <mat-option value="0">No</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastname" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Address</mat-label>
              <input matInput formControlName="Address" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>City</mat-label>
              <input matInput formControlName="City" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>State</mat-label>
              <input matInput formControlName="State" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="Zip" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Phone#</mat-label>
              <input matInput formControlName="Phone" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Fax#</mat-label>
              <input matInput formControlName="Fax" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Email</mat-label>
              <input matInput formControlName="Email" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Password</mat-label>
              <input matInput formControlName="Password" />
            </mat-form-field>
          </div>
          <div
            style="margin-top: 2vh"
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            *ngIf="PerfilCustomer"
          >
            <mat-slide-toggle
              class="
                example-margin
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
              [(ngModel)]="permiso1value"
              [checked]="permiso1value"
              [disabled]="permiso1"
            >
              Search Order
            </mat-slide-toggle>
            <mat-slide-toggle
              class="
                example-margin
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
              [(ngModel)]="permiso2value"
              [checked]="permiso2value"
              [disabled]="permiso2"
            >
              Place Order
            </mat-slide-toggle>
            <mat-slide-toggle
              class="
                example-margin
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
              [(ngModel)]="permiso3value"
              [checked]="permiso3value"
              [disabled]="permiso3"
            >
              Inventory Available
            </mat-slide-toggle>
          </div>
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            style="margin-top: 6vh"
          >
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                btn-group
              "
            >
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              >
                <button
                  mat-raised-button
                  color="danger"
                  class="
                    col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                  "
                  (click)="OncancekUsers()"
                >
                  Cancel
                </button>
              </div>
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              >
                <button
                  mat-raised-button
                  color="primary"
                  class="
                    col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                  "
                  (click)="OnNewOrEditUsers()"
                >
                  {{ EditarTxto }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          style="margin-top: 6vh"
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          *ngIf="viewUsers"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-form-field appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput (keyup)="applyFilterSearch($event)" #input2 />
              <button
                mat-button
                matSuffix
                mat-icon-button
                color="primary"
                (click)="openDialogLector2()"
                aria-label="Example icon button with a menu icon"
              >
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
              <mat-hint>Filter Table</mat-hint>
            </mat-form-field>
            <div
              class="
                example-container
                mat-elevation-z8
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <div class="example-table-container">
                <table
                  mat-table
                  [dataSource]="dataSourceSearch"
                  matSort
                  #sortSearch="matSort"
                  class="example-table"
                  matSortDirection="desc"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="id" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">

                      <button mat-icon-button [matMenuTriggerFor]="menuUsers" aria-label="Example icon-button with a menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menuUsers="matMenu">
                        <button mat-menu-item  (click)="OnEditarUsers(row)">
                
                          <span>Edit</span>
                        </button>
                       
                        <button mat-menu-item   (click)="OpenDialogEmailConfingSend(row)">
                
                          <span> settings email copy send</span>
                        </button>
                      </mat-menu>
                      
                     
                    
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="ClientAccNum">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Client Acc Num</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.ClientAccNum }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Name</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">
                        {{ row.Name }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Last_Name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Last Name</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">
                        {{ row.Last_Name }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="User_Address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">User Address</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">
                        {{ row.User_Address }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="City">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      City
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.City }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="User_State">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">User State</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.User_State }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Zip">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Zip Code
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Zip }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Phone
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Phone }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Ext">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Ext
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Ext }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Cell_Phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Cell Phone#</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.Cell_Phone }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Fax">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Fax#</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.Fax }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Email</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.Email }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="UserPassword">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">User Password</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.UserPassword }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Active">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Active
                    </th>
                    <td mat-cell *matCellDef="let row">
      <ng-container *ngIf="row.Active==true; else elseTemplate">
        <div>Yes</div>
      </ng-container>
      <ng-template #elseTemplate>
        <div>No</div>
      </ng-template>
      
                     
                     
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="AcceptedTOS">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Accepted TOS</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.AcceptedTOS }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="AcceptedTOSDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Accepted TOS Date</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.AcceptedTOSDate }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="PictureLocation">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Picture Location</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.PictureLocation }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="IMSApp">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Ims App</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.IMSApp }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblAppThemeID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">App Theme</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblAppThemeID }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Date_Created">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Date Created</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.Date_Created }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblAppThemeBGColor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">App Theme Bg Color</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblAppThemeBGColor }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblAppThemeFontColor">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Font Color</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblAppThemeFontColor }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblAppThemeFontSize">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Font Size</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblAppThemeFontSize }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblAppThemeFontFamily" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Font
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblAppThemeFontFamily }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsSearch"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsSearch"
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No data matching the filter "{{ input2.value }}"
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <mat-paginator
              [pageSizeOptions]="[10000]"
              #paginatorSearch="matPaginator"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Item Location">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          [formGroup]="FormularioLocalizzacion"
        >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
          >
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Location</mat-label>
              <input matInput formControlName="Location" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Length</mat-label>
              <input matInput type="number" formControlName="Length" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Width</mat-label>
              <input matInput type="number" formControlName="Width" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Height</mat-label>
              <input matInput type="number" formControlName="Heigth" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Temperature</mat-label>
              <input matInput type="number" formControlName="Temperature" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Low Quantity</mat-label>
              <input matInput type="number" formControlName="quantity" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Description</mat-label>
              <input matInput formControlName="Description" />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            >
              <mat-label>Storage Type</mat-label>
              <mat-select disableRipple formControlName="Type">
                <input
                  matInput
                  (keyup)="onKey($event.target.value)"
                  placeholder="search"
                />
                <mat-option
                  [value]="item.key"
                  *ngFor="let item of arraytypeLocationselest"
                  >{{ item.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="success"
              (click)="openDialogTypeLocation()"
              aria-label="Example icon button with a menu icon"
              class="col-md-2"
              style="margin-top: 2vh"
            >
              Add
              <mat-icon>plus</mat-icon>
            </button>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Active</mat-label>
              <mat-select disableRipple formControlName="checked">
                <mat-option value="0">No</mat-option>
                <mat-option value="1">Yes</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            style="margin-top: 6vh"
          >
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                btn-group
              "
            >
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              >
                <button
                  mat-raised-button
                  color="danger"
                  class="
                    col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                  "
                  (click)="OnClearLocalitation()"
                >
                  Cancel
                </button>
              </div>
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              >
                <button
                  mat-raised-button
                  color="primary"
                  class="
                    col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                  "
                  (click)="OnLocationNewOrEdit()"
                >
                  {{ ButtonLocalizzacionText }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          style="margin-top: 6vh"
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          *ngIf="!editarLocalizacion"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-form-field appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput (keyup)="applyFilterLocation($event)" #input />
              <button
                mat-button
                matSuffix
                mat-icon-button
                color="primary"
                (click)="openDialogLector()"
                aria-label="Example icon button with a menu icon"
              >
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
              <mat-hint>Filter Table</mat-hint>
            </mat-form-field>
            <div
              class="
                example-container
                mat-elevation-z8
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <button
                mat-button
                matSuffix
                mat-icon-button
                color="success"
                (click)="exportAsExcel()"
                aria-label="Example icon button with a menu icon"
                class="col-md-12"
              >
                Excel

                <mat-icon>cloud_download</mat-icon>
              </button>
              <div class="example-table-container" #exportExcel>
                <table
                  mat-table
                  [dataSource]="dataSource"
                  matSort
                  #TableLocaSort="matSort"
                  class="example-table"
                  matSortActive="created"
                  matSortDisableClear
                  matSortDirection="desc"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="id" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <button
                        mat-raised-button
                        style="width: 87px; height: 43px"
                        (click)="OnEditarLocalitation(row)"
                      >
                        Edit
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.location }}</div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="locationLength">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location length</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.locationLength }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="locationWidth">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location Width</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.locationWidth }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="locationHeight">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location Height</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
						{{ row.locationHeight }}
					</td>
                  </ng-container>
                  <ng-container matColumnDef="locationTemperature">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location Temperature</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">
                        {{ row.locationTemperature }}
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="lowQuantity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Low Quantity</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.lowQuantity }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="locationDescription">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location Description</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.locationDescription }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="locationType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Location Type</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.locationType }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="active" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Active
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.active }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No Data Matching The Filter "{{ input.value }}"
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <mat-paginator
              #paginadorlo="matPaginator"
              [pageSizeOptions]="[5, 10, 25, 100]"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Company charges">
      <mat-tab-group
        mat-align-tabs="center"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        [selectedIndex]="indexTabs24.value"
        (selectedIndexChange)="indexTabs24.setValue($event)"
      >
        <mat-tab label="Company charges" [disabled]="tabfalse">
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            style="margin-top: 5vh"
          >
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FomCompanyCharges">
              <mat-form-field appearance="fill" class="col-md-6">
                <mat-label>Invoice list</mat-label>
                <mat-select
                  formControlName="invoiceList"
                  (selectionChange)="onselectchanger($event)"
                >
                  <mat-option
                    *ngFor="let topping of ResponseInvoiceItemsList"
                    [value]="topping"
                    >{{ topping.value }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="col-md-3">
                <mat-label>Accessorial</mat-label>
                <input
                  matInput
                  placeholder="Accessorial"
                  formControlName="Accessorial"
                />
              </mat-form-field>
              <mat-form-field appearance="fill" class="col-md-3">
                <mat-label>Charge Amount</mat-label>
                <input
                  matInput
                  placeholder="Charge Amount"
                  formControlName="Amount"
                  type="number"
                />
              </mat-form-field>
              <div class="col-md-2">
                <section class="example-section" style="margin-top: 2vh">
                  <mat-checkbox class="example-margin" formControlName="Active"
                    >Active</mat-checkbox
                  >
                </section>
              </div>

              <div class="col-md-2">
                <section class="example-section" style="margin-top: 2vh">
                  <mat-checkbox
                    class="example-margin"
                    formControlName="Integrated"
                    >QB Integrated</mat-checkbox
                  >
                </section>
              </div>
              <div class="col-md-2">
                <section class="example-section" style="margin-top: 2vh">
                  <mat-checkbox
                    class="example-margin"
                    formControlName="IntegratedStatus"
                    >QB Integrated Status</mat-checkbox
                  >
                </section>
              </div>
              <div
                class="
                  col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 row
                "
              >
                <button
                  mat-raised-button
                  color="danger"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  (click)="OnCancelCompany()"
                >
                  Calcel
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  (click)="OnInsertOREditCompanyCharges()"
                >
                  Save
                </button>
              </div>

              <div
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
                style="margin-top: 2vh"
              >
                <mat-form-field
                  appearance="fill"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                >
                  <mat-label>Select an option</mat-label>
                  <mat-select [(value)]="selectedCOmpanyCharges">
                    <mat-option value="1">Active</mat-option>
                    <mat-option value="0">Inactive</mat-option>
                  </mat-select>
                </mat-form-field>
                <button
                  mat-raised-button
                  color="danger"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  (click)="OnChargesCompanyView()"
                >
                  Search
                </button>
              </div>
            </div>

            <div class="col-md-12" style="margin-top: 2vh">
              <mat-form-field appearance="standard">
                <mat-label>Search</mat-label>
                <input
                  matInput
                  (keyup)="applyFilterCompanyCharges($event)"
                  placeholder="Search"
                  #inputCompanyCharges
                />
              </mat-form-field>

              <div class="example-container mat-elevation-z8">
                <table
                  mat-table
                  [dataSource]="CompanyChargesdataSource"
                  matSort
                  #CompanyChargesSort="matSort"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="Id" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <button
                        mat-raised-button
                        color="primary"
                        class="
                          col-xs-12
                          col-sm-12
                          col-md-12
                          col-lg-12
                          col-xl-12
                          col-xxl-12
                        "
                        (click)="OnEditCompanyChages(row)"
                      >
                        Edit
                      </button>
                      <button
                        mat-raised-button
                        color="success"
                        class="
                          col-xs-12
                          col-sm-12
                          col-md-12
                          col-lg-12
                          col-xl-12
                          col-xxl-12
                        "
                        (click)="OnAddCustomer(row)"
                      >
                        Add customer
                      </button>
                    </td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="CompanyID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      CompanyID
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.CompanyID }}</td>
                  </ng-container>

                  <!-- ID Column -->
                  <ng-container matColumnDef="Accessorial">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Accessorial
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Accessorial }}
                    </td>
                  </ng-container>

                  <!-- ID Column -->
                  <ng-container matColumnDef="ChargeAmount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      ChargeAmount
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.ChargeAmount }}
                    </td>
                  </ng-container>

                  <!-- ID Column -->
                  <ng-container matColumnDef="Date_Created">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Date_Created
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Date_Created }}
                    </td>
                  </ng-container>

                  <!-- ID Column -->
                  <ng-container matColumnDef="Active">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Active
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.Active }}</td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="tblInvoiceListID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      tblInvoiceListID
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblInvoiceListID }}
                    </td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="QBIntegrated">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      QBIntegrated
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.QBIntegrated }}
                    </td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="QBIntegratedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      QBIntegratedDate
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.QBIntegratedDate }}
                    </td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="QBIntegratedStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      QBIntegratedStatus
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.QBIntegratedStatus }}
                    </td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="QBListID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      QBListID
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.QBListID }}</td>
                  </ng-container>
                  <!-- ID Column -->
                  <ng-container matColumnDef="QBChartOfAccount" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      QBChartOfAccount
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.QBChartOfAccount }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblChartOfAccount" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      ChartOfAccountID
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblChartOfAccount }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="CompanyChargesdisplayedColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: CompanyChargesdisplayedColumns
                    "
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No data matching the filter "{{
                        inputCompanyCharges.value
                      }}"
                    </td>
                  </tr>
                </table>
              </div>

              <mat-paginator
                matPaginator
                #CompanyChargesPaginator="matPaginator"
                [pageSizeOptions]="[5, 10, 25, 100]"
                aria-label="Select page of users"
              ></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Customers charges" [disabled]="tab1">
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            style="margin-top: 5vh"
          >
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
              [formGroup]="FromCustomerCharges"
            >
              <mat-form-field appearance="fill" class="col-md-8">
                <mat-label>Customer</mat-label>
                <mat-select formControlName="custome">
                  <mat-option
                    *ngFor="let topping of PlaceOrderCustomer"
                    [value]="topping.key"
                    >{{ topping.value }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="col-md-2">
                <mat-label>Amount</mat-label>
                <input matInput placeholder="Amount" formControlName="Amount" />
              </mat-form-field>
              <div class="col-md-2">
                <section class="example-section" style="margin-top: 2vh">
                  <mat-checkbox class="example-margin" formControlName="Active"
                    >Active</mat-checkbox
                  >
                </section>
              </div>
              <div
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                <button
                  mat-raised-button
                  color="danger"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  (click)="OnClearCustomerCharge()"
                >
                  Calcel
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  (click)="OnCustomerChargesNew()"
                >
                  Save
                </button>
              </div>

              <div
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
                style="margin-top: 2vh"
              >
                <mat-form-field
                  appearance="fill"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                >
                  <mat-label>Select an option</mat-label>
                  <mat-select [(value)]="selectedCustomerCharges">
                    <mat-option value="1">Active</mat-option>
                    <mat-option value="0">Inactive</mat-option>
                  </mat-select>
                </mat-form-field>
                <button
                  mat-raised-button
                  color="danger"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  (click)="OnCustomerCharges()"
                >
                  Search
                </button>
              </div>
            </div>

            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <mat-form-field appearance="standard">
                <mat-label>Search</mat-label>
                <input
                  matInput
                  (keyup)="applyFilter($event)"
                  placeholder="Search"
                  #inputCustomerCharges
                />
              </mat-form-field>

              <div class="mat-elevation-z8">
                <table
                  mat-table
                  [dataSource]="CustomerChargesSource"
                  matSort
                  #CustomerChargesSort="matSort"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="OnEditCutstomerCharges(row)"
                      >
                        Edit
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="tblCustomerID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      tblCustomerID
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblCustomerID }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Company_Name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Company_Name
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Company_Name }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tblCompanyChargesID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      tblCompanyChargesID
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.tblCompanyChargesID }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Amount
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.Amount }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Active">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Active
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.Active }}</td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="CustomerChargesdisplayedColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: CustomerChargesdisplayedColumns
                    "
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No data matching the filter "{{
                        inputCustomerCharges.value
                      }}"
                    </td>
                  </tr>
                </table>
              </div>
              <mat-paginator
                matPaginator
                #CustomerChargesPaginator="matPaginator"
                [pageSizeOptions]="[5, 10, 25, 100]"
                aria-label="Select page of users"
              ></mat-paginator>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
    <mat-tab label="Routing Description">
      <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
    <div  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FormRouting">
      <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-8">
        <mat-label>Description</mat-label>
        <input matInput  maxlength="50" formControlName="Description" >
        
      </mat-form-field>
      <section class="example-section col-md-4" style="margin-top: 2vh;">
        <mat-checkbox class="example-margin" formControlName="Active">Active</mat-checkbox>
      </section>
      <button mat-raised-button  color="primary" class="col-md-12" (click)="OnNewOrEditRouting()">Save</button>
    </div>
   
<div class="col-md-12" style="margin-top: 3vh;" *ngIf="viewRouting">
  <mat-form-field appearance="fill">
    <mat-label>Select an option</mat-label>
    <mat-select [(value)]="selectedDescription" (selectionChange)="OnSelectRoutingVariable($event)">
      <mat-option value="1">Active</mat-option>
      <mat-option value="0">Inactive</mat-option>
 
    </mat-select>
  </mat-form-field>
 <div class="col-md-12" style="height: 300px;overflow: auto;" >
  <mat-selection-list #shoes [multiple]="false">
    <mat-list-option *ngFor="let shoe of arrayDescripionRouting" [value]="shoe" (click)="OnEdit(shoe)">
     
     Key:  {{shoe.key}}
      
      Text: {{shoe.value}}
      
      Note: for editing just click on the text
    <br>
    <br>
         
    </mat-list-option>
  </mat-selection-list>
 </div>
</div>
      </div>
    </mat-tab>
    <mat-tab label="Warehouse Name">
      <div  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FormWarehouseName">
        <mat-form-field hintLabel="Max 100 characters" appearance="fill" class="col-md-2">
          <mat-label>Werehouse Name</mat-label>
          <input matInput  maxlength="100" formControlName="Warehouse_Name" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-2">
          <mat-label>Contact Name</mat-label>
          <input matInput  maxlength="50" formControlName="Contact_Name" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 100 characters" appearance="fill" class="col-md-2">
          <mat-label>Address</mat-label>
          <input matInput  maxlength="100" formControlName="Address" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 100 characters" appearance="fill" class="col-md-2">
          <mat-label>Address1</mat-label>
          <input matInput  maxlength="100" formControlName="Address1" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 100 characters" appearance="fill" class="col-md-2">
          <mat-label>City</mat-label>
          <input matInput  maxlength="100" formControlName="City" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-2">
          <mat-label>State</mat-label>
          <input matInput  maxlength="50" formControlName="State" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-2">
          <mat-label>Zip Code</mat-label>
          <input matInput  maxlength="50" formControlName="Zip" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-2">
          <mat-label>Phone#</mat-label>
          <input matInput  maxlength="50" formControlName="Phone" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-2">
          <mat-label>Fax#</mat-label>
          <input matInput  maxlength="50" formControlName="Fax" >
          
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters" appearance="fill" class="col-md-2">
          <mat-label>Email</mat-label>
          <input matInput  maxlength="50" formControlName="Email" >
          
        </mat-form-field>
        <mat-form-field  appearance="fill" class="col-md-2">
          <mat-label>order By</mat-label>
          <input matInput  type="number" formControlName="orderBy" >
          
        </mat-form-field>
        <button mat-raised-button style="height: 30px;"   color="primary" class="col-md-1" (click)="onSaveFormWarehouseNameLocation()">Save</button>

        <button mat-raised-button  style="height: 30px;" color="primary" class="col-md-1" (click)="onCleaarFromWarehouseName()">Clear</button>
      </div>

      <div  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" >
        <table
       
        class="table table-success table-striped-columns"
      >
        <thead>
          <tr>
            <th>Option</th>

            <th>Warehouse Name</th>
            <th>Contact Name</th>
            <th>Address</th>
            <th>City</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of ResponseWarehouseNameLocationArray">
            <td>
              <button
              mat-icon-button
              [matMenuTriggerFor]="mensu"
              aria-label="menu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #mensu="matMenu">
              <button  mat-menu-item  color="primary"   (click)="openDialogWarehouseName(item)">location with products</button>
              <button  mat-menu-item  color="primary"   (click)="onEditFromWarehouseName(item)">Edit</button>
              <button  mat-menu-item  color="primary"   (click)="openDialogWarehouseNamewithoutProducts(item)">location without products</button>

            </mat-menu>
             
            </td>

            <td>
              {{item.Warehouse_Name}}
            </td>
            <td>{{item.Contact_Name}}</td>
            <td>{{item.Address}}</td>
            <td>{{item.City}}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>
